import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
} from '@angular/core';

@Component({
  selector: 'app-avatar',
  imports: [],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'group',
    '[class.loaded]': 'loaded()',
  },
})
export class AvatarComponent {
  public readonly src = input<string>();
  public readonly alt = input<string>();
  public readonly loaded = signal(false);

  constructor() {
    effect(() => {
      this.src();

      this.loaded.set(false);
    });
  }

  handleImageLoad() {
    this.loaded.set(true);
  }
}
